import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "..";

const requestBaseQuery = baseQuery("orders");

export const ordersApi = createApi({
  reducerPath: "orders",
  baseQuery: requestBaseQuery,
  tagTypes: ["order"],
  endpoints: (builder) => ({
    addOrder: builder.mutation({
      query: (orderDetails) => ({
        type: "POST",
        data: orderDetails,
      }),
      invalidatesTags: [{ type: "order", id: "LIST" }],
    }),
    getOrders: builder.query({
      query: () => ({
        type: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "order", id })), // Provide individual order tags
              { type: "order", id: "LIST" }, // Provide LIST tag for the whole order list
            ]
          : [{ type: "order", id: "LIST" }],
    }),
    getOrderDetail: builder.query({
      query: ({ filter }) => ({
        type: "GET",
        filters: filter ?? undefined,
      }),
      providesTags: () => [{ type: "order", id: "LIST" }],
    }),
    updateOrder: builder.mutation({
      query: (details) => ({
        type: "PATCH",
        data: details,
        id: details.id,
      }),
      invalidatesTags: ["order"],
    }),
  }),
});

export const { useAddOrderMutation, useGetOrdersQuery, useGetOrderDetailQuery, useUpdateOrderMutation } = ordersApi;
